// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1LtGz","large":"styles_large__20XKF"};